module.exports = __webpack_public_path__ + "img/qr.f2d1f2af.png";